'use strict';
var parent = require('../../stable/instance/splice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/splice.js
// module id = 539
// module chunks = 13